import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Reveal from '../../components/Reveal';
import Icon from '../../components/Icon';
import usePageTitle from '../../hooks/usePageTitle';
import forNanniesFeature from '../../assets/images/for-nannies-feature.jpg';

export default function ForNannies() {
  const { t } = useTranslation();
  usePageTitle(t('forNannies.pageTitle'));
  const benefits = t('forNannies.benefits', { returnObjects: true });
  const steps = t('forNannies.steps', { returnObjects: true });
  const needed = t('forNannies.needed', { returnObjects: true });

  return (
    <>
      <section className="page-hero page-hero-alt">
        <div className="shell">
          <Reveal>
            <span className="eyebrow">{t('forNannies.eyebrow')}</span>
            <h1>{t('forNannies.title')}</h1>
            <p className="lede">{t('forNannies.lede')}</p>
            <div className="hero-actions">
              <Link className="btn btn-primary btn-lg" to="/register/nanny">{t('forNannies.startApplication')}</Link>
              <Link className="btn btn-outline btn-lg" to="/jobs">{t('forNannies.seeOpenJobs')}</Link>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <div className="feature-grid">
            <Reveal className="feature-media">
              <img src={forNanniesFeature} alt="A nanny laughing with a toddler she is caring for" />
            </Reveal>
            <Reveal className="feature-copy" delay={100}>
              <span className="eyebrow">{t('forNannies.realNannies')}</span>
              <h2>{t('forNannies.featureTitle')}</h2>
              <p>{t('forNannies.featureBody')}</p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <div className="benefit-grid">
            {benefits.map((b, i) => (
              <Reveal key={b.title} className="benefit" delay={i * 80}>
                <span className="promise-icon"><Icon name={b.icon} /></span>
                <h3>{b.title}</h3>
                <p>{b.body}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="band band-tint">
        <div className="shell">
          <Reveal className="section-head">
            <span className="eyebrow">{t('forNannies.applying')}</span>
            <h2>{t('forNannies.applyingTitle')}</h2>
          </Reveal>
          <ol className="timeline-steps">
            {steps.map((step, i) => (
              <Reveal as="li" key={step.title} delay={i * 90}>
                <span className="step-number">{i + 1}</span>
                <div>
                  <h3>{step.title}</h3>
                  <p>{step.body}</p>
                </div>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <div className="two-col">
            <Reveal>
              <span className="eyebrow">{t('forNannies.beforeYouStart')}</span>
              <h2>{t('forNannies.haveTheseReady')}</h2>
              <p className="section-lede">{t('forNannies.haveTheseReadyLede')}</p>
            </Reveal>
            <Reveal delay={120}>
              <ul className="check-list">
                {needed.map((item) => (
                  <li key={item}><span className="check-mark"><Icon name="check" size={14} strokeWidth={2.2} /></span>{item}</li>
                ))}
              </ul>
            </Reveal>
          </div>

          <Reveal className="cta-band" delay={100}>
            <div>
              <h2>{t('forNannies.joinTeam')}</h2>
              <p>{t('forNannies.joinTeamBody')}</p>
            </div>
            <Link className="btn btn-primary btn-lg" to="/register/nanny">{t('forNannies.becomeNanny')}</Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
